import { useProfile } from "../types/Profile";
import { Bicon, Button } from "../util/BootstrapIcons";

export default function Header() {
    const [profile] = useProfile();
    return <header className="py-2 align-items-center d-flex flex-wrap" style={{ borderBottom: '2px solid #0056b3' }}>
        <a className="align-items-center d-flex flex-wrap text-decoration-none nav-link" href="./">
            <img src="./csm-logo.png" style={{ maxHeight: 60 }} alt="Logotipo CSM" />
            <div className="ps-3 d-flex flex-column">
                <h5 className="m-0 fw-bold" style={{ color: '#0056b3' }}>ECLI</h5>
                <small className="text-muted">Conselho Superior da Magistratura</small>
            </div>
        </a>
        
        <div className="flex-fill d-none d-lg-block"></div>
        
        <pre className="m-0 me-3 small text-secondary">v.{process.env.REACT_APP_VERSION_COMMIT}</pre>
        
        <Button title="Perfil" i="palette2" text={`Perfil${profile?.name? `: ${profile.name}` : ''}`} className="btn btn-sm btn-outline-secondary m-1 p-1" data-bs-toggle="modal" data-bs-target="#modal-profile" />
        
        <nav className="d-print-none">
            <ul className="container d-flex nav align-items-center">
                <a className="nav-link fs-6 fw-bold text-dark" href="https://docs.google.com/document/..." rel="noreferrer" target="_blank">
                    <Bicon n="question-circle" /> Ajuda
                </a>
            </ul>
        </nav>
    </header>
}


